import React, { Component } from 'react'
// import { Carousel } from 'antd';
// import img1 from '../../../static/images/affiliate-banner.jpg'
// import product1 from '../../../static/images/product-1.png'
// import product3 from '../../../static/images/product-3.png'

// import analysis1 from '../../../static/images/analysis1.png'

// import step1 from '../../../static/images/step1.png'
// import more1 from '../../../static/images/more-member1.png'

// import advantage2 from '../../../static/images/advantage2.png'
// import advantage3 from '../../../static/images/advantage3.png'
// import advantage4 from '../../../static/images/advantage4.png'
// import advantage5 from '../../../static/images/advantage5.png'

import './index.less';
class Affiliate extends Component {
    state = {
        iframeHeight: 600,
    }

    componentDidMount() {
        this._onAffiliateIframeMessage = (e) => {
            const d = e.data
            if (!d || d.source !== 'affiliate-iframe' || typeof d.height !== 'number') return
            if (d.height < 200) return
            this.setState({ iframeHeight: d.height })
        }
        window.addEventListener('message', this._onAffiliateIframeMessage)
    }

    componentWillUnmount() {
        window.removeEventListener('message', this._onAffiliateIframeMessage)
    }

    syncIframeHeightFromContent = (iframe) => {
        if (!iframe) return
        try {
            const doc = iframe.contentDocument || iframe.contentWindow.document
            const h = Math.max(
                doc.documentElement.scrollHeight,
                doc.body.scrollHeight,
                doc.documentElement.offsetHeight,
                doc.body.offsetHeight
            )
            if (h > 200) {
                this.setState({ iframeHeight: h })
            }
        } catch (err) {
            // cross-origin: rely on postMessage from affiliate.html
        }
    }

    render() {
        const { iframeHeight } = this.state
        return (
            <div style={{ width: '100%' }}>
                <iframe
                    title="affiliate-static"
                    src={`${process.env.PUBLIC_URL}/static/affiliate/affiliate.html`}
                    style={{ width: '100%', height: iframeHeight, border: 'none', display: 'block', overflow: 'hidden' }}
                    onLoad={(e) => this.syncIframeHeightFromContent(e.target)}
                />
            </div>

            //  <div className="product_container unattended-container affiliate-container">
            //     <div className="top-home-carousel">
            //         <div className="banner-bg"><img className="banner-img" src={img1} alt="" /></div>
            //         <div className="mode-mark"></div>
            //         <div className="mask-top-content">
            //             <div className="content-pos">
            //                 <div className="content-left-text">
            //                     <div className="banner-top-title">全渠道电子会员卡</div>
            //                     <div className="banner-top-tips">打通微信+支付宝原生电子会员卡，</div>
            //                     <div className="banner-top-tips">可以轻量快速的切入到门店,同时高效精准的抓住每一个消费者,帮助商户快速的积累门店的私域流量,同时实现会员的精准标签,精准触达,精准营销</div>
            //                     <div className="banner-top-btn">立即体验</div>
            //                 </div>

            //             </div>

            //         </div>
            //     </div>

            //     <div className="common-block-home unattended-first">
            //         <div className="common-block-product">
            //             <div className="store-model">
            //                 <div className="store-model-title">会员</div>
            //                 <div className="store-model-title">大数据分析</div>
            //                 <img className="unattended-img-style" src={analysis1} alt="" />
            //                 <div className="store-model-tips">会员结构、消费习惯、寄存状态等数据精细化呈现，为营销员熟悉会员、管理会员、进行会员营销提供数据支持。</div>
            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-title">营销</div>
            //                 <div className="store-model-title">卡券功能</div>
            //                 <img className="unattended-img-style" src={analysis1} alt="" />
            //                 <div className="store-model-tips">卡券功能超多卡种满足你的几乎市面上所有的卡券功能呢，如会员卡（包含折扣，积分和储值等）、优惠券（包含满减、折扣和代金券等），购物卡（包含储值、次卡/月卡/季卡/年卡）等，你可以自由选择电子卡券形式也可以额外印制实体卡券。</div>

            //             </div>
            //             <div className="store-model">
            //                 <div className="store-model-title">全渠道</div>
            //                 <div className="store-model-title">卡券营销</div>
            //                 <img className="unattended-img-style" src={analysis1} alt="" />
            //                 <div className="store-model-tips">对接微信卡包，会员卡领取更便捷；线上线下卡券全打通。</div>
            //             </div>
            //         </div>
            //     </div>


            //     <div className="common-block-home product-page">
            //         <div className="common-block-home-title">电子会员卡核心亮点</div>
            //         <div className="common-block-product">
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     一键开卡
            //                 </div>
            //                 <div className="product-detail-tips">打通微信底层数据，自动拉取用户开卡数据，一键开卡，简便的体验可以让开卡量快随提升。</div>
            //                 <img className="product-detail-img" src={step1} alt="" />

            //             </div>
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     支付码即会员码
            //                 </div>
            //                 <div className="product-detail-tips">以支付为入口，支付自动开卡，开卡自动送券，支付自动识别会员，自动核销。</div>
            //                 <img className="product-detail-img" src={step1} alt="" />

            //             </div>
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     有效全量触达
            //                 </div>
            //                 <div className="product-detail-tips">通过微信服务通知模板消息，让您随时都可以免费的、100%有效的触达会员，节约短信成本同事提高效率。</div>
            //                 <img className="product-detail-img" src={step1} alt="" />

            //             </div>
            //             <div className="product-detail product-detail-page unattended-first-page">
            //                 <div className="first-page-title">
            //                     精准营销
            //                 </div>
            //                 <div className="product-detail-tips">后台根据会员的消费数据可以做各种维度的标签，支持自由筛选，您可以根据标签所分层的人群进行精准的营销。</div>
            //                 <img className="product-detail-img" src={step1} alt="" />

            //             </div>

            //         </div>

            //     </div>

            //     <div className="common-block-home advantage-common-block-home">

            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">O2O全渠道卡</div>
            //                     <div className="advantage-detail-left-tips">会员卡与实体卡打通实体卡绑定、新会员注册均可对接微信、支付宝卡包，一键扫码省时又省力，存于微信卡包，调出使用更快捷</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage2} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">一键开卡</div>
            //                     <div className="advantage-detail-left-tips">会员拉新从此不再困扰，用户只需扫描二维码即可加入门店会员，无需手工填写表单和繁琐的注册流程。</div>
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">O2O全渠道卡券营销</div>
            //                     <div className="advantage-detail-left-tips">线下优惠券可线上查看并使用，线上优惠券亦可在线下买单使用，实现卡券完全互通；积分换购、直接购券等多种积分设置，开卡、转介绍、消费均可以累计积分，进行商品换购或直接抵用金额。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage3} alt="" />
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style4" src={advantage4} alt="" />
            //                 </div>
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">会员管理</div>
            //                     <div className="advantage-detail-left-tips">将顾客从潜客到熟客的各阶段进行细分促进会员熟化过程，有效进行会员忠诚度管理</div>
            //                     <div className="advantage-detail-left-tips">提供会员消费额、返店数及客单价排行等数据全面掌握会员消费情况</div>
            //                 </div>
            //             </div>

            //         </div>
            //         <div className="advantage-detail">
            //             <div className="advantage-detail-content">
            //                 <div className="advantage-detail-left">
            //                     <div className="advantage-detail-left-title">会员标签</div>
            //                     <div className="advantage-detail-left-tips">多维度标签给会员多角度贴标签，基本信息及消费习惯等多维度监控为针对性营销提供信息依据</div>
            //                     <div className="advantage-detail-left-tips">精准营销，会员流失少，全方位的营销筛选条件，可根据卡券余额、购买习惯、购买频次、购买历史、生日信息等筛选营销对象。</div>
            //                 </div>
            //                 <div className="advantage-detail-right">
            //                     <img className="member-img-style" src={advantage5} alt="" />
            //                 </div>
            //             </div>
            //         </div>

            //     </div>

            //     <div className="common-block-home advantage-common-block-home product-page-more">
            //         <div className="common-block-home-title">更多电子会员卡能力</div>
            //         <div className="member-detail-service">
            //             <Carousel autoplay>
            //                 <div className="more-card-model">
            //                     <div className="more-card-model-content">
            //                         <img className="carousel-card-img" src={more1} alt="" />
            //                         <div className="card-title">储值营销</div>
            //                         <div className="card-tips">设定储值档次，会员在线即可直接选择储值，设定赠送余额，储值即可显示数据资产余额，</div>
            //                         <div className="card-more-click">了解更多 &gt;</div>
            //                     </div>
            //                     <div className="more-card-model-content">
            //                         <img className="carousel-card-img" src={more1} alt="" />
            //                         <div className="card-title">付费卡</div>
            //                         <div className="card-tips">设定储值档次，会员在线即可直接选择储值，设定赠送余额，储值即可显示数据资产余额，</div>
            //                         <div className="card-more-click">了解更多 &gt;</div>
            //                     </div>
            //                     <div className="more-card-model-content">
            //                         <img className="carousel-card-img" src={more1} alt="" />
            //                         <div className="card-title">计次卡</div>
            //                         <div className="card-tips">设定储值档次，会员在线即可直接选择储值，设定赠送余额，储值即可显示数据资产余额，</div>
            //                         <div className="card-more-click">了解更多   &gt;</div>
            //                     </div>
            //                 </div>
            //                 <div className="more-card-model">
            //                     <div className="more-card-model-content">
            //                         <img className="carousel-card-img" src={more1} alt="" />
            //                         <div className="card-title">储值营销</div>
            //                         <div className="card-tips">设定储值档次，会员在线即可直接选择储值，设定赠送余额，储值即可显示数据资产余额，储值关联会员晋级和权益效果更佳，设置员工分组，增长显著！</div>
            //                         <div className="card-more-click">了解更多 &gt;</div>
            //                     </div>
            //                     <div className="more-card-model-content">
            //                         <img className="carousel-card-img" src={more1} alt="" />
            //                         <div className="card-title">付费卡</div>
            //                         <div className="card-tips">强力锁定客户消费的必备武器，圈出你的忠诚客户！对于用户来说“钱在哪，心就在哪”，所以愿意为你的会员权益付费的用户，一定是你的“高净值客户”</div>
            //                         <div className="card-more-click">了解更多 &gt;</div>
            //                     </div>
            //                     <div className="more-card-model-content">
            //                         <img className="carousel-card-img" src={more1} alt="" />
            //                         <div className="card-title">计次卡</div>
            //                         <div className="card-tips">次卡、周卡、月卡、季卡、年卡强力锁定客户消费的必备武器，圈出你的忠诚客户！对于用户来说“钱在哪，心就在哪”，所以愿意为你的会员权益付费的用户，一定是你的“高净值客户”</div>
            //                         <div className="card-more-click">了解更多   &gt;</div>
            //                     </div>
            //                 </div>
                           
            //             </Carousel>
            //         </div>
                    
            //     </div>





            // </div >
        )
    }
}

export default Affiliate
